module.exports = __webpack_public_path__ + "static/media/autotask.d1608a50.png";